import React from 'react';
import { Heading } from '.';

export const ContactDetails = (props) => {
  const { subHeading, contactEmail, contactName, contactPhone } = props.contactDetails;
  return (
    <div className="contact-details__contact-list contact col-xs-12 col-md-4">
      <Heading content={subHeading} size="h3" style={props.headingColor} />
      <ul className="contact__list list-unstyled">
        <li className="contact__list-item">
          <i className="fa fa-user" style={props.textColor} />
          <span style={props.textColor}>{contactName}</span>
        </li>
        <li className="contact__list-item">
          <i className="fa fa-phone" style={props.textColor} />
          <span><a href={`tel:${contactPhone}`} style={props.textColor} target="_blank">{contactPhone}</a></span>
        </li>
        <li className="contact__list-item">

          <i className="fa fa-envelope" style={props.textColor} />
          <span><a href={`mailto:${contactEmail}`} style={props.textColor} target="_blank">{contactEmail}</a></span>
        </li>
      </ul>
    </div>
  )
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/ContactDetails.js